// Umwandlung zwischen Klartext (SMS) und der einfachen HTML-Form der Editoren (Runde 8, Agent 8D, Textbausteine).

const BLOECKE = new Set(["DIV", "P", "LI", "UL", "OL", "BLOCKQUOTE", "H1", "H2", "H3", "H4", "TR"]);

/** HTML -> Klartext mit Zeilenumbrüchen (für SMS und die Vorschau). */
export function htmlZuText(html: string): string {
  const d = document.createElement("div");
  d.innerHTML = html;
  const teile: string[] = [];
  const laufen = (knoten: Node) => {
    if (knoten.nodeType === Node.TEXT_NODE) {
      teile.push(knoten.textContent ?? "");
      return;
    }
    if (knoten.nodeType !== Node.ELEMENT_NODE) return;
    const el = knoten as HTMLElement;
    if (el.tagName === "SCRIPT" || el.tagName === "STYLE") return;
    if (el.tagName === "BR") {
      teile.push("\n");
      return;
    }
    const block = BLOECKE.has(el.tagName);
    if (block && teile.length && !teile[teile.length - 1].endsWith("\n")) teile.push("\n");
    el.childNodes.forEach(laufen);
    if (block && !(teile[teile.length - 1] ?? "").endsWith("\n")) teile.push("\n");
  };
  d.childNodes.forEach(laufen);
  return teile.join("").replace(/ /g, " ").replace(/[ \t]+\n/g, "\n").replace(/\n{3,}/g, "\n\n").trim();
}

function maskiert(text: string): string {
  return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

/** Klartext -> HTML (eine Zeile je `div`, Leerzeilen als `<br>`), wie der Server es für Klartext macht. */
export function textZuHtml(text: string): string {
  return text
    .replace(/\r\n/g, "\n")
    .split("\n")
    .map((z) => (z.trim() ? `<div>${maskiert(z)}</div>` : "<div><br></div>"))
    .join("");
}

/** Kurzer Klartext-Auszug für Tabellen. */
export function vorschauText(inhalt: string, kanal: string, laenge = 90): string {
  const text = (kanal === "sms" ? inhalt : htmlZuText(inhalt)).replace(/\s+/g, " ").trim();
  return text.length > laenge ? `${text.slice(0, laenge - 1)}…` : text;
}
